import { render, staticRenderFns } from "./form-json.vue?vue&type=template&id=2fdbfa94&scoped=true&"
import script from "./form-json.vue?vue&type=script&lang=js&"
export * from "./form-json.vue?vue&type=script&lang=js&"
import style0 from "./form-json.vue?vue&type=style&index=0&id=2fdbfa94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fdbfa94",
  null
  
)

export default component.exports